import { Spacing } from '@persona-id/design-tokens';

import FormControlLabel from 'dashboard/components/FormControls/FormControlLabel';
import HoverCopyableField from 'dashboard/components/HoverCopyableField';
import { MonoSpan } from 'dashboard/components/Typography';
import FormOrganizationDetails, {
  FormOrganizationDetailsData,
} from 'dashboard/forms/FormOrganizationDetails';
import { Container, Header, Section } from 'dashboard/layouts/IndexViewLayoutV2';
import { Environment } from 'dashboard/models/environment';
import { Organization } from 'dashboard/models/organization';
import Card from 'design-system/components/Card';
import Sticker from 'design-system/components/Sticker';
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from 'design-system/components/Table';
import { ApiModel } from 'lib/interfaces/api';

interface DashboardOrganizationInformationViewProps {
  organization: Organization | undefined;
  environments: Environment[];
  currentEnvironment: Environment;
  updateOrganizationDetails: (values: FormOrganizationDetailsData) => Promise<void>;
}

const DashboardOrganizationInformationView = ({
  organization,
  environments,
  currentEnvironment,
  updateOrganizationDetails,
}: DashboardOrganizationInformationViewProps) => {
  return (
    <Container>
      <Header title='Organization' />
      {organization && (
        <Section>
          <Card>
            <Card.Body>
              <Card.Title>Details</Card.Title>
              <FormControlLabel style={{ marginBottom: 0 }}> Organization ID </FormControlLabel>
              <HoverCopyableField copyValue={organization.id}>
                <MonoSpan>{organization.id}</MonoSpan>
              </HoverCopyableField>
              <FormOrganizationDetails
                initialValues={organization.attributes}
                onSubmit={updateOrganizationDetails}
              />
            </Card.Body>
          </Card>

          <Card>
            <Card.Body>
              <Card.Title>Environments</Card.Title>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableHeaderCell>Name</TableHeaderCell>
                    <TableHeaderCell>Type</TableHeaderCell>
                    <TableHeaderCell>ID</TableHeaderCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {environments.map((environment) => (
                    <TableRow key={environment.id}>
                      <TableCell>
                        {environment.attributes.name}
                        {environment.id === currentEnvironment?.id && (
                          <Sticker style={{ marginLeft: `${Spacing[3]}` }} variant='blue'>
                            Current
                          </Sticker>
                        )}
                      </TableCell>
                      <TableCell>
                        {environment.type === ApiModel.EnvironmentProduction ? (
                          <Sticker variant='primary'>Production</Sticker>
                        ) : (
                          <Sticker variant='orange'>Sandbox</Sticker>
                        )}
                      </TableCell>
                      <TableCell>
                        <HoverCopyableField copyValue={environment.id}>
                          <MonoSpan>{environment.id}</MonoSpan>
                        </HoverCopyableField>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Card.Body>
          </Card>
        </Section>
      )}
    </Container>
  );
};
export default DashboardOrganizationInformationView;
